var _defs, _polyline, _polyline2, _polyline3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeighingPan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffce00;\n      }\n\n      .cls-2 {\n        fill: #ffd400;\n      }\n\n      .cls-3 {\n        fill: #697daf;\n      }\n\n      .cls-4 {\n        fill: #fff68a;\n      }\n\n      .cls-5 {\n        fill: #ffec00;\n      }\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "998.56 70.58 998.56 1486.23 981.5 1486.23 981.5 70.58"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "997.78 67 1578.79 1326.16 1563.29 1333.31 982.28 74.15"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "997.78 74.15 416.77 1333.31 401.27 1326.16 982.28 67"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M999.87,1856c393.13,0,711.82-246.17,711.82-549.84H288.06c0,303.67,318.69,549.84,711.82,549.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1308.6,1306.16c0,249.59-215.31,460.3-510.27,527.45,63.91,14.55,131.53,22.39,201.54,22.39,393.13,0,711.82-246.17,711.82-549.84h-403.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1711.69,1306.16H288.06c0,33.63,3.92,66.54,11.41,98.5h1400.82c7.48-31.96,11.41-64.87,11.41-98.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 211.79,
    y: 1274.93,
    width: 1576.16,
    height: 87.16,
    rx: 5.75,
    ry: 5.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1764.55,1274.93h-369.2c12.93,0,23.41,10.48,23.41,23.41v40.34c0,12.93-10.48,23.41-23.41,23.41h369.2c12.93,0,23.41-10.48,23.41-23.41v-40.34c0-12.93-10.48-23.41-23.41-23.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 605.69,
    cy: 1581.08,
    rx: 73.29,
    ry: 128.04,
    transform: "translate(-890.4 788.37) rotate(-41.12)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeighingPan);
export default __webpack_public_path__ + "static/media/WeighingPan.b54235ebebf49c7ff90af4816db7d9c8.svg";
export { ForwardRef as ReactComponent };